const axios = require('axios')

class ChatterService {
  constructor({ url, channelId, token }) {
    this.baseUrl = url
    this.channelId = channelId
    this.token = token
    this.axios = axios.create({
      baseURL: this.baseUrl,
      headers: {Authorization: `Bearer ${this.token}`}
    })

    this.xmpp = {
      host: null,
      websocket: null
    }
  }

  async loadServerSettings() {
    if (this.xmpp && this.xmpp.host && this.xmpp.websocket) {
      return this.xmpp
    }

    let res = await this.axios.get('/v1/settings')
    let xmpp = res.data.xmpp
    this.xmpp = {
      host: xmpp.host,
      websocket: xmpp.websocket
    }

    return this.xmpp
  }

  async getNewCredentials() {
    let res = await this.axios.post('/v1/user/get-new', {channelId: this.channelId})
    let { user, host, password } = res.data
    return { user, host, password }
  }

  async uploadFile(file) {
    let formData = new FormData()
    formData.append('file', file)
    let res = await this.axios.post(
      '/v1/upload-file',
      formData,
      {headers: {'Content-Type': 'multipart/form-data'}}
    )
    let {url} = res.data

    return {url}
  }
}

module.exports = ChatterService